export const AUDIT_LOG_RECORD_TYPES = {
  pipeline: {
    childTypes: [{ type: 'integration', via: 'pipeline_integrations' }],
    scopeValueFields: ['id', 'name', 'writekey'],
  },
  integration: {
    childTypes: [],
    scopeValueFields: ['id'],
  },
};

export function getChildTypes(entity) {
  assertKnownEntity(entity);
  return AUDIT_LOG_RECORD_TYPES[entity].childTypes;
}

export function getScopeValueFields(entity) {
  assertKnownEntity(entity);
  return AUDIT_LOG_RECORD_TYPES[entity].scopeValueFields;
}

function assertKnownEntity(entity) {
  if (!(entity in AUDIT_LOG_RECORD_TYPES)) {
    throw new Error(`Unknown audit-log entity '${entity}' — add it to AUDIT_LOG_RECORD_TYPES`);
  }
}
